<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button title="back page" (click)="backToLeaveBalance()">
                                      <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">Leave Balance Report</h3>
                            </div>
                        </div>
                    </div>
                    <div class="row my-1 align-items-center">
                        <form [formGroup] = "leaveBalanceYearForm">
                            <div class="col-sm-12 col-md-12 col-lg-8">
                                <div class="row my-2 justify-content-center" >
                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div class="input">
                                            <div class="input-item">
                                                <select formControlName="year">
                                                    <option value="" disabled selected>Select Year</option>
                                                    <!-- <option value="2024">2024</option> -->
                                                    <option value="2025">2025</option>
                                                    <option value="2026">2026</option>
                                                </select>
                                                <label class="loating-label floating-label-special">Select Year</label> 
                                                <i class="ri-calendar-line"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                                        <button type="button" class="btn" (click)=getLeaveBalanceReport()>
                                            <div>Submit</div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <ag-grid-angular
                        style="width: auto; height: 100%;"
                        class="ag-theme-material"
                        [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef"
                        [animateRows]="true"
                        [rowData]="rowData"
                        (gridReady)="onGridReady($event)"
                    ></ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>
